import React from 'react';

const Hero = ({ onOpenModal }) => {
  const dallasAreas = [
    'Downtown Dallas', 'Uptown', 'Plano', 'Frisco', 
    'Irving', 'Garland', 'Richardson', 'Allen'
  ];

  return (
    <section id="home" className="relative pt-32 pb-20 md:pt-40 md:pb-28 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img 
          src="https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80" 
          alt="Dallas Skyline" 
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/90 to-black/70"></div>
      </div>

      <div className="container-custom relative z-10">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          
          <div className="text-white">
            <div className="flex items-center gap-2 mb-4">
              <svg className="w-6 h-6 text-propwhiz-accent" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
              </svg>
              <span className="text-propwhiz-accent font-semibold">Proudly Serving Dallas-Fort Worth</span>
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-6">
              We Buy Dallas Houses.{' '}
              <span className="text-propwhiz-accent">Fast Cash. No Repairs.</span>
            </h1>
            <p className="text-xl md:text-2xl mb-8 text-gray-200">
              Get a fair cash offer within 24 hours. Close in as little as 7 days.
            </p>
            
            <div className="mb-10">
              <p className="text-sm uppercase tracking-wider text-gray-300 mb-3">
                We buy houses in these Dallas areas:
              </p>
              <div className="flex flex-wrap gap-2">
                {dallasAreas.map((area) => (
                  <span key={area} className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-medium border border-white/30">
                    {area}
                  </span>
                ))}
              </div>
            </div>

            <div className="flex flex-wrap gap-4">
              <button 
                onClick={onOpenModal}
                className="btn-primary text-lg bg-propwhiz-accent hover:bg-cyan-600 border-0"
              >
                Get Your Cash Offer Now →
              </button>
              <button className="btn-secondary bg-transparent text-white border-white hover:bg-white hover:text-propwhiz-blue">
                Learn More
              </button>
            </div>
          </div>

          {/* Right Content - Updated to an Invitation Box instead of form inputs */}
          <div className="bg-white/95 backdrop-blur-sm rounded-3xl shadow-2xl p-8 text-center border-t-4 border-propwhiz-accent">
            <div className="w-20 h-20 bg-propwhiz-accent/10 rounded-full flex items-center justify-center mx-auto mb-6">
              <svg className="w-10 h-10 text-propwhiz-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
              </svg>
            </div>
            <h3 className="text-3xl font-bold text-propwhiz-dark mb-4">
              Ready to sell your home?
            </h3>
            <p className="text-gray-600 mb-8 text-lg">
              Avoid the hassle of agents, repairs, and months of waiting. Get a fair, all-cash offer today.
            </p>
            <button 
              onClick={onOpenModal}
              className="w-full btn-primary text-xl py-4 bg-propwhiz-accent hover:bg-cyan-600 shadow-xl"
            >
              Start Your Cash Offer →
            </button>
            <p className="text-sm text-gray-500 mt-4">100% Free. No Obligation.</p>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Hero;